"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminMenuDetail = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../common");
const constant_1 = require("./constant");
exports.AdminMenuDetail = react_1.default.memo(({ menu, setMenu }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_1.default.Fragment, null, constant_1.MENU_LIST.map(item => (react_1.default.createElement(common_1.Button, { key: item, className: `admin-menu-detail-btn ${menu === item ? 'active' : ''}`, text: `${t(`menu.${item}`)}`, onClick: () => {
            setMenu(item);
        } })))));
});
